import React, { useEffect, useRef, useState } from "react";
import "./BookingAndCancellationCard.scss";
import ChevronIcon from "../../common/images/chevron-down.svg";
import ContentLoader from "react-content-loader";
import FlightIcon from "../../common/images/p_flight.svg";
import carIcon from "../../common/images/car.svg";
import bedIcon from "../../common/images/Bed.svg";
import activityIcon from "../../common/images/activity.svg";
import foodIcon from "../../common/images/Food.svg";
import flagIcon from "../../common/images/flag.svg";
import CircleIcon from "@mui/icons-material/Circle";
import { showPriceValue } from "../Helpers/SettingHelper";
import axios from "axios";
import { apiglobaltixMediaUrl, PDFApiUrl } from "../Helpers/Config";
import cookie from "react-cookies";
import { saveAs } from "file-saver";
import { BottomSheet } from "react-spring-bottom-sheet";
import FlightTabDisabledIcon from "../../common/images/my-acc-flight-tab-disabled-icon.svg";
import FlightTabEnabledIcon from "../../common/images/my-acc-flight-tab-enabled-icon.svg";
import VacationTabDisabledIcon from "../../common/images/my-acc-vacation-tab-disabled-icon.svg";
import VacationTabEnabledIcon from "../../common/images/my-acc-vacation-tab-enabled-icon.svg";
import TTDTabDisabledIcon from "../../common/images/my-acc-TTD-tab-disabled-icon.svg";
import TTDTabEnabledIcon from "../../common/images/my-acc-TTD-enabled-icon.svg";
import { pplaceholder } from "../Helpers/Images";
import { GET_BOOKINGHISTORY } from "../../actions";
import { connect } from "react-redux";
import TTDLocationIcon from "../../common/images/ttd-location-icon.svg";
import ExpandArrowIcon from "../../common/images/chevron-up.svg";

const BookingAndCancellationCard = (props) => {
  const {
    state,
    pageFor,
    buttonLoader,
    activeTab: propsActiveTab,
    bookingList: propsBookingList,
    totalCount,
    getBookingHistory,
    cancellTicket,
  } = props;
  const [activeTab, setActiveTab] = useState(propsActiveTab || "vacation");
  const [showFilterSheet, setShowFilterSheet] = useState(false);
  const [loading, setLoading] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("");
  const [bookingList, setBookingList] = useState([]);
  const [existBookingList, setExistBookingList] = useState([]);
  const [showBookingDetails, setShowBookingDetails] = useState([]);
  const [page, setPage] = useState(1);
  const [pageList, setPageList] = useState(null);

  const tabs = [
    { key: "vacation", label: "vacation" },
    { key: "flight", label: "flight" },
    { key: "ttd", label: "Things to do" },
  ];
  const tabIcons = [
    {
      name: "vacation",
      disable: VacationTabDisabledIcon,
      enable: VacationTabEnabledIcon,
    },
    {
      name: "flight",
      disable: FlightTabDisabledIcon,
      enable: FlightTabEnabledIcon,
    },
    { name: "ttd", disable: TTDTabDisabledIcon, enable: TTDTabEnabledIcon },
  ];
  const flightClasses = [
    {
      key: "Y",
      value: "Economy",
    },
    {
      key: "C",
      value: "Business",
    },
    {
      key: "F",
      value: "First class",
    },
    {
      key: "S",
      value: "Premium economy",
    },
    {
      key: "Y",
      value: "Economy",
    },
  ];
  const filterOptions = [
    {
      label: "latest Bookings",
      value: "latestBookings",
    },
    {
      label: "Last Day",
      value: "lastDay",
    },
    {
      label: "Last Week",
      value: "lastWeek",
    },
    {
      label: "Last Month",
      value: "lastMonth",
    },
    {
      label: "Last 3 Months",
      value: "last3Months",
    },
    {
      label: "Last 6 Months",
      value: "last6Months",
    },
    {
      label: "Last Year",
      value: "lastYear",
    },
  ];
  const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
  const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];

  const fliterRef = useRef(null);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutSideFilter);
    return () => {
      document.removeEventListener("mousedown", handleClickOutSideFilter);
    };
  }, []);

  useEffect(() => {
    handleGetPackages();
  }, [page, activeTab]);

  useEffect(() => {
    if (propsBookingList !== existBookingList) {
      // let updatedBookingList = [];
      // if (bookingList.length > 0) {
      //   updatedBookingList = bookingList.concat(propsBookingList);
      // } else {
      //   updatedBookingList = propsBookingList;
      // }
      setBookingList(propsBookingList);
      setExistBookingList(propsBookingList);
    }
    let pageList = [];

    if (totalCount > 0) {
      const totalPages = Math.ceil(totalCount / 10);
      for (let i = 1; i <= totalPages; i++) {
        pageList.push(i);
      }
    }
    setPageList(pageList);
  }, [propsBookingList]);

  const handleGetPackages = async () => {
    setLoading("package");

    const params = new URLSearchParams();
    const type = pageFor === "bookings" ? "BOOKED" : "CANCELLED";

    if (state.userId !== "") {
      params.append("customer_id", state.userId);
      params.append("type", type);
      params.append("source", activeTab);
      params.append("page", page);
    }

    const queryString = params.toString();

    try {
      await getBookingHistory(queryString);
    } catch (error) {
      console.error("Error fetching booking history:", error);
    } finally {
      setTimeout(() => {
        setLoading("");
      }, 5000);
    }
  };

  const handleClickOutSideFilter = (event) => {
    if (fliterRef.current && !fliterRef.current.contains(event.target)) {
      setShowFilterSheet(false);
    }
  };

  const resultCountDesign = () => {
    // const activeTabLabel = tabs.find((item) => item.key === activeTab)?.label;
    // const validList = Array.isArray(bookingList) ? bookingList : [];
    // const showResultCount = validList.filter(
    //   (item) => item.filter === activeTabLabel
    // ).length;

    return (
      <h5>
        {loading === "package" ? (
          <em>Loading...</em>
        ) : (
          <>
            Your {pageFor}{" "}
            <span>
              {bookingList.length} / {totalCount}
            </span>
          </>
        )}
      </h5>
    );
  };

  const imageContainerDesign = (thumbnail) => {
    const thumbNailSrc = thumbnail
      ? thumbnail.includes("https")
        ? thumbnail
        : apiglobaltixMediaUrl + thumbnail
      : pplaceholder;
    return (
      <div className="mybooking-card__img-cntnr">
        <img src={thumbNailSrc} alt="ThumbNailImage" />
      </div>
    );
  };

  const bookingDetailsDesign = (item) => {
    return (
      <>
        <div className="mybooking-card__booking-details">
          {state.isMobile && (
            <div
              className="details-chevron-cntnr"
              onClick={() => handleShowBookingDetails("booking-details")}
            >
              <span>Booking details</span>
              <img
                src={ChevronIcon}
                alt="ChevronIcon"
                className={
                  showBookingDetails.includes("booking-details")
                    ? "chevron-collapsed"
                    : ""
                }
              />
            </div>
          )}
          <ul
            className={`${
              !state.isMobile || showBookingDetails.includes("booking-details")
                ? "detail-hidden"
                : ""
            }`}
          >
            <li>
              <span>Booking ref ID </span>
              <br />
              <strong>{item.booking_reference_number}</strong>
            </li>
            <li>
              <span>No of travelers</span>
              <br />
              <strong>
                {item.adults > 0 && <>{item.adults} x adult</>}
                {item.child > 0 && <>, {item.child} x child</>}
                {item.infant > 0 && <>, {item.infant} x infant</>}
              </strong>
            </li>
            <li>
              <span>Payment ref ID</span>
              <br />
              <strong>
                {item.booking_payment_reference !== "" &&
                item.booking_payment_reference !== null
                  ? item.booking_payment_reference
                  : item.booking_reference_number}
              </strong>
            </li>
          </ul>
        </div>
      </>
    );
  };

  const handleShowBookingDetails = (value) => {
    setShowBookingDetails((prevList) => {
      return prevList.includes(value)
        ? prevList.filter((item) => item !== value)
        : [...prevList, value];
    });
  };

  const priceContainerDesign = (item) => {
    return (
      <div className="mybooking-card__price-cntnr">
        <div className="mybooking-card__price-cntnr__price">
          <p>Total paid</p>
          <strong>
            {showPriceValue(item.booking_payAmount, item.booking_currency)}
          </strong>
          <span>All inclusive fees and tax</span>
        </div>
        {pageFor === "bookings" ? (
          <div className="mybooking-card__price-cntnr__action">
            <button
              onClick={() => cancellTicket(item)}
              className="btn--secondary"
            >
              Cancel/Modify Booking
            </button>
            <button
              onClick={() => downloadTicket(item)}
              className="btn-primary"
            >
              {loading === "download" && buttonLoader("primary")}Download ticket
            </button>
          </div>
        ) : (
          <span className="mybooking-card__price-cntnr__cancel-txt">
            Cancelled
          </span>
        )}
      </div>
    );
  };

  const formatDateTime = (date, need) => {
    let result;
    const dateObj = new Date(date);

    if (need === "date") {
      const dayName = days[dateObj.getDay()];
      const day = dateObj.getDate();
      const month = months[dateObj.getMonth()];
      const year = String(dateObj.getFullYear()).slice(2);
      const formattedDate = `${dayName}, ${day} ${month} ${year}`;
      result = formattedDate;
    } else {
      const hours = String(dateObj.getHours()).padStart(2, "0");
      const minutes = String(dateObj.getMinutes()).padStart(2, "0");
      const formattedTime = `${hours}:${minutes}`;
      result = formattedTime;
    }
    return result;
  };

  const getFlightDetail = (item, tripType, key) => {
    const { flightItineraries } = item;
    if (!flightItineraries?.ItinerarySegments?.length) return "";

    const typeIndex =
      tripType === "Return"
        ? flightItineraries.ItinerarySegments.length - 1
        : 0;

    const detail = flightItineraries.ItinerarySegments[typeIndex];

    switch (key) {
      case "classType": {
        const flightClassCode = detail.CabinClass;
        return (
          flightClasses.find((val) => val.key === flightClassCode)?.value || ""
        );
      }
      case "OperatingAirlineCode":
        return detail.OperatingAirlineCode || "";

      case "airline_name":
        return detail.airline_name || "";

      case "JourneyDuration":
        return flightJourneyDuration(detail.JourneyDuration) || "";

      case "DepartureDate":
        return formatDateTime(detail.DepartureDateTime, "date");

      case "DepartureTime":
        return formatDateTime(detail.DepartureDateTime, "time");

      case "ArrivalDate":
        return formatDateTime(detail.ArrivalDateTime, "date");

      case "ArrivalTime":
        return formatDateTime(detail.ArrivalDateTime, "time");

      case "DepartureAirportLocationCode":
        return detail.DepartureAirportLocationCode || "";

      case "ArrivalAirportLocationCode":
        return detail.ArrivalAirportLocationCode || "";

      default:
        return "";
    }
  };

  const displayBookingList = () => {
    let result = "";
    if (!bookingList?.length > 0) {
      result = null;
    } else {
      if (activeTab === "vacation") {
        result = (
          <div className="mybooking-card-cntnr">
            {bookingList
              .filter((data) => data.filter === "vacation")
              .map((item, index) => {
                return (
                  <div className="mybooking-card" key={index}>
                    {imageContainerDesign(item.thumbnail)}
                    <div className="mybooking-vacation-card__details-cntnr">
                      <h2>
                        {item.packageName !== ""
                          ? item.packageName
                          : "Own Package"}
                      </h2>
                      {bookingDetailsDesign(item)}
                    </div>
                    <div
                      className={`mybooking-vacation-card__booking-status-cntnr ${
                        !state.isMobile ||
                        showBookingDetails.includes("booking-status")
                          ? ""
                          : "booking-sts-bg"
                      }`}
                    >
                      {pageFor === "bookings" && (
                        <>
                          {state.isMobile ? (
                            <div
                              className="details-chevron-cntnr"
                              onClick={() =>
                                handleShowBookingDetails("booking-status")
                              }
                            >
                              <div
                                className={`package-status-box ${
                                  item.booking_reference_number
                                    ? "result--success"
                                    : "result--danger"
                                }`}
                              >
                                <p>
                                  {item.booking_reference_number
                                    ? "Booked Successfully"
                                    : "Booking failed"}
                                </p>
                              </div>
                              <img
                                src={ChevronIcon}
                                alt="ChevronIcon"
                                className={
                                  showBookingDetails.includes("booking-status")
                                    ? "chevron-collapsed"
                                    : ""
                                }
                              />
                            </div>
                          ) : (
                            <div
                              className={`package-status-box ${
                                item.booking_reference_number
                                  ? "result--success"
                                  : "result--danger"
                              }`}
                            >
                              <p>
                                {item.booking_reference_number
                                  ? "Booked Successfully"
                                  : "Booking failed"}
                              </p>
                            </div>
                          )}
                        </>
                      )}
                      <div
                        className={`package-included-box ${
                          !state.isMobile ||
                          showBookingDetails.includes("booking-status")
                            ? "detail-hidden"
                            : ""
                        }`}
                      >
                        {item.flight === "Yes" && (
                          <div className="package-included-box__item">
                            <img src={FlightIcon} alt="flightIcon" />
                            Flight
                          </div>
                        )}
                        {item.transfer === "Yes" && (
                          <div className="package-included-box__item">
                            <img src={carIcon} alt="carIcon" />
                            Transport
                          </div>
                        )}
                        {item.hotel === "Yes" && (
                          <div className="package-included-box__item">
                            <img src={bedIcon} alt="bedIcon" />
                            Stay
                          </div>
                        )}
                        {item.totalActivity !== 0 && (
                          <div className="package-included-box__item">
                            <img src={activityIcon} alt="activityIcon" />
                            Activities
                          </div>
                        )}
                        {/* <div className="package-included-box__item">
                          <img src={flagIcon} alt="flagIcon" />
                          Guide
                        </div>
                        <div className="package-included-box__item">
                          <img src={foodIcon} alt="foodIcon" />
                          Food and beverage
                        </div> */}
                      </div>
                    </div>
                    {priceContainerDesign(item)}
                  </div>
                );
              })}
          </div>
        );
      } else if (activeTab === "flight") {
        result = (
          <div className="mybooking-card-cntnr">
            {bookingList
              .filter((value) => value.filter === "flight")
              .map((item, index) => {
                return (
                  <div key={index} className="mybooking-card">
                    <div className="mybooking-flight-card__route-cntnr">
                      <div className="sep-fc-root top-root">
                        <div className="sep-fc-info">
                          <div className="sep-fc-type">
                            Onward
                            <CircleIcon />
                          </div>
                          <div className="sep-fc-type">
                            {getFlightDetail(item, "Onward", "classType")}{" "}
                            <CircleIcon />
                          </div>
                          <div className="sep-fc-logo">
                            <div
                              className={
                                "Airline-Image airline-" +
                                getFlightDetail(
                                  item,
                                  "Onward",
                                  "OperatingAirlineCode"
                                )
                              }
                            ></div>
                            <span>
                              {getFlightDetail(item, "Onward", "airline_name")}
                            </span>
                          </div>
                        </div>
                        <div className="sep-fc-path">
                          <div className="sep-fc-img">
                            <span>
                              {getFlightDetail(
                                item,
                                "Onward",
                                "JourneyDuration"
                              )}
                            </span>
                            <img
                              className="flight-root"
                              src={FlightIcon}
                              alt="FlightIcon"
                            />
                            <span>
                              {item.stops > 0
                                ? `${item.stops} Stop`
                                : "Nonstop"}
                            </span>
                          </div>
                          <div className="sep-fc-detail from-detail">
                            <div className="sep-fc-date">
                              {getFlightDetail(item, "Onward", "DepartureDate")}
                            </div>
                            <div className="sep-fc-time">
                              {getFlightDetail(item, "Onward", "DepartureTime")}
                            </div>
                            <div className="sep-fc-code">
                              {getFlightDetail(
                                item,
                                "Onward",
                                "DepartureAirportLocationCode"
                              )}
                            </div>
                          </div>
                          <div className="sep-fc-detail to-detail">
                            <div className="sep-fc-date">
                              {getFlightDetail(item, "Onward", "ArrivalDate")}
                            </div>
                            <div className="sep-fc-time">
                              {getFlightDetail(item, "Onward", "ArrivalTime")}
                            </div>
                            <div className="sep-fc-code">
                              {getFlightDetail(
                                item,
                                "Onward",
                                "ArrivalAirportLocationCode"
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {item.TripType === "Return" && (
                        <div className="sep-fc-root bottom-root">
                          <div className="sep-fc-info">
                            <div className="sep-fc-type">
                              Return
                              <CircleIcon />
                            </div>
                            <div className="sep-fc-type">
                              {getFlightDetail(item, "Return", "classType")}
                              <CircleIcon />
                            </div>
                            <div className="sep-fc-logo">
                              <div
                                className={
                                  "Airline-Image airline-" +
                                  getFlightDetail(
                                    item,
                                    "Return",
                                    "OperatingAirlineCode"
                                  )
                                }
                              ></div>
                              <span>
                                {getFlightDetail(
                                  item,
                                  "Return",
                                  "airline_name"
                                )}
                              </span>
                            </div>
                          </div>
                          <div className="sep-fc-path">
                            <div className="sep-fc-img">
                              <span>
                                {getFlightDetail(
                                  item,
                                  "Return",
                                  "JourneyDuration"
                                )}
                              </span>
                              <img
                                className="flight-root"
                                src={FlightIcon}
                                alt="FlightIcon"
                              />
                              <span>
                                {item.returnstops > 0
                                  ? `${item.returnstops} Stop`
                                  : "Nonstop"}
                              </span>
                            </div>
                            <div className="sep-fc-detail from-detail">
                              <div className="sep-fc-date">
                                {getFlightDetail(
                                  item,
                                  "Return",
                                  "DepartureDate"
                                )}
                              </div>
                              <div className="sep-fc-time">
                                {getFlightDetail(
                                  item,
                                  "Return",
                                  "DepartureTime"
                                )}
                              </div>
                              <div className="sep-fc-code">
                                {getFlightDetail(
                                  item,
                                  "Return",
                                  "DepartureAirportLocationCode"
                                )}
                              </div>
                            </div>
                            <div className="sep-fc-detail to-detail">
                              <div className="sep-fc-date">
                                {getFlightDetail(item, "Return", "ArrivalDate")}
                              </div>
                              <div className="sep-fc-time">
                                {getFlightDetail(item, "Return", "ArrivalTime")}
                              </div>
                              <div className="sep-fc-code">
                                {getFlightDetail(
                                  item,
                                  "Return",
                                  "ArrivalAirportLocationCode"
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="sep-fc-tag-cntnr">
                        <div className="sep-fc-tag-cntnr__row">
                          {item?.flightItineraries.BaggageInfo?.length > 0 ? (
                            <>
                              {item.flightItineraries.BaggageInfo.map(
                                (baggageItem, index) => {
                                  let result = null;
                                  if (index === 0) {
                                    let passenger = "adult";
                                    let value = "";
                                    if (baggageItem === "SB") {
                                      value = "Standard Baggage";
                                    } else {
                                      value = baggageItem;
                                    }

                                    result = (
                                      <>
                                        {passenger === "adult" && (
                                          <div
                                            key={index}
                                            className="sep-fc-tag-cntnr__row__tag"
                                          >
                                            Checkin: {value} per {passenger}
                                          </div>
                                        )}
                                      </>
                                    );
                                  }
                                  return result;
                                }
                              )}
                            </>
                          ) : (
                            <div className="sep-fc-tag-cntnr__row__tag">
                              Checkin: NA
                            </div>
                          )}
                          {item?.flightItineraries.CabinBaggageInfo?.length >
                          0 ? (
                            <>
                              {item.flightItineraries.CabinBaggageInfo.map(
                                (baggageItem, index) => {
                                  let result = null;
                                  if (index === 0) {
                                    let passenger = "adult";
                                    let value = "";
                                    if (baggageItem === "SB") {
                                      value = "Standard Baggage";
                                    } else {
                                      value = baggageItem;
                                    }

                                    result = (
                                      <>
                                        {passenger === "adult" && (
                                          <div
                                            key={index}
                                            className="sep-fc-tag-cntnr__row__tag"
                                          >
                                            Cabin: {value} per {passenger}
                                          </div>
                                        )}
                                      </>
                                    );
                                  }
                                  return result;
                                }
                              )}
                            </>
                          ) : (
                            <div className="sep-fc-tag-cntnr__row__tag">
                              Cabin: NA
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="mybooking-ttd-card__booking-details-cntnr">
                      <div className="mybooking-ttd-card__booking-details-cntnr__header">
                        <p>Flight details</p>
                      </div>
                      {bookingDetailsDesign(item)}
                      {pageFor === "bookings" && (
                        <div
                          className={`result-status-box ${
                            item.flight_booking_status === "CONFIRMED"
                              ? "result--success"
                              : item.flight_booking_status === "WAITING"
                              ? "result-warning"
                              : "result--danger"
                          }`}
                        >
                          <p>
                            {item.flight_booking_status === "CONFIRMED"
                              ? "Booked Successfully"
                              : item.flight_booking_status === "WAITING"
                              ? "Waiting for confirmation"
                              : "Booking failed"}
                          </p>
                        </div>
                      )}
                    </div>
                    {priceContainerDesign(item)}
                  </div>
                );
              })}
          </div>
        );
      } else if (activeTab === "ttd") {
        result = (
          <div className="mybooking-card-cntnr">
            {bookingList
              .filter((data) => data.filter === "Things to do")
              .map((item, index) => {
                return (
                  <div className="mybooking-card" key={index}>
                    {imageContainerDesign(item.thumbnail)}
                    <div className="mybooking-ttd-card__details-cntnr">
                      <h3>
                        {item.packageName !== ""
                          ? item.packageName
                          : "Own Package"}
                      </h3>
                      <span>
                        <img src={TTDLocationIcon} alt="TTDLocationIcon" />
                        {item.ttd_location}
                      </span>
                    </div>
                    <div className="mybooking-ttd-card__booking-details-cntnr">
                      <div className="mybooking-ttd-card__booking-details-cntnr__header">
                        <p>Things to do details</p>
                      </div>
                      {bookingDetailsDesign(item)}
                      {pageFor === "bookings" && (
                        <div
                          className={`result-status-box ${
                            item.booking_reference_number
                              ? "result--success"
                              : "result--danger"
                          }`}
                        >
                          <p>
                            {item.booking_reference_number
                              ? "Booked Successfully"
                              : "Booking failed"}
                          </p>
                        </div>
                      )}
                    </div>
                    {priceContainerDesign(item)}
                  </div>
                );
              })}
          </div>
        );
      }
    }
    return result;
  };

  const downloadTicket = async (item) => {
    setLoading("download");
    try {
      const res = await axios.get(
        `${PDFApiUrl}/eticket/download?bookingid=${item.booking_id}`,
        {
          headers: {
            Authorization: cookie.load("acccesstoken"),
          },
          responseType: "arraybuffer",
        }
      );
      const pdfBlob = new Blob([res.data], { type: "application/pdf" });
      saveAs(pdfBlob, `${item.packageName}.pdf`);
    } catch (err) {
      console.error(err);
    }
    setLoading("");
  };

  const handleFilterChange = (value) => {
    setLoading("package");
    let selectedFilter = value;
    const { filterBookings } = state;

    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const lastWeek = new Date(today);
    lastWeek.setDate(today.getDate() - 7);
    const lastMonth = new Date(today);
    lastMonth.setMonth(today.getMonth() - 1);
    const lastThreeMonths = new Date(today);
    lastThreeMonths.setMonth(today.getMonth() - 3);
    const lastSixMonths = new Date(today);
    lastSixMonths.setMonth(today.getMonth() - 6);
    const lastYear = new Date(today);
    lastYear.setFullYear(today.getFullYear() - 1);
    let filteredBookings = filterBookings?.slice();
    setTimeout(() => {
      if (selectedFilter === "latestBookings") {
        filteredBookings = filterBookings?.slice().sort((a, b) => {
          const dateA = new Date(a.booking_created_on);
          const dateB = new Date(b.booking_created_on);
          return dateB - dateA;
        });
      } else if (selectedFilter === "lastDay") {
        filteredBookings = filterBookings?.filter((item) => {
          const bookingDate = new Date(item.booking_created_on);
          return bookingDate >= yesterday && bookingDate <= today;
        });
      } else if (selectedFilter === "lastWeek") {
        filteredBookings = filterBookings?.filter((item) => {
          const bookingDate = new Date(item.booking_created_on);
          return bookingDate >= lastWeek && bookingDate <= today;
        });
      } else if (selectedFilter === "lastMonth") {
        filteredBookings = filterBookings?.filter((item) => {
          const bookingDate = new Date(item.booking_created_on);
          return bookingDate >= lastMonth && bookingDate <= today;
        });
      } else if (selectedFilter === "last3Months") {
        filteredBookings = filterBookings?.filter((item) => {
          const bookingDate = new Date(item.booking_created_on);
          return bookingDate >= lastThreeMonths && bookingDate <= today;
        });
      } else if (selectedFilter === "last6Months") {
        filteredBookings = filterBookings?.filter((item) => {
          const bookingDate = new Date(item.booking_created_on);
          return bookingDate >= lastSixMonths && bookingDate <= today;
        });
      } else if (selectedFilter === "lastYear") {
        filteredBookings = filterBookings?.filter((item) => {
          const bookingDate = new Date(item.booking_created_on);
          return bookingDate >= lastYear && bookingDate <= today;
        });
      } else {
        filteredBookings = filterBookings;
      }
      setSelectedFilter(selectedFilter, () => {});
      // setBookingList(filteredBookings);
      setShowFilterSheet(false);
      setLoading("");
    }, 1000);
  };

  const filterOptionValue = () => {
    let result = "";
    if (selectedFilter === "latestBookings") {
      result = "Latest bookings";
    } else if (selectedFilter === "lastDay") {
      result = "Last day";
    } else if (selectedFilter === "lastWeek") {
      result = "Last week";
    } else if (selectedFilter === "lastMonth") {
      result = "Last month";
    } else if (selectedFilter === "last3Months") {
      result = "Last 3 months";
    } else if (selectedFilter === "last6Months") {
      result = "Last 6 month";
    } else if (selectedFilter === "lastYear") {
      result = "Last year";
    } else {
      result = "Filter by";
    }
    return result;
  };

  const handleChangeActiveTab = (key) => {
    setBookingList([]);
    setExistBookingList([]);
    setPage(1);
    setActiveTab(key);
    return null;
  };

  const flightJourneyDuration = (time) => {
    const hours = Math.floor(time / 60);
    const minutes = time % 60;

    const hourLabel = hours === 1 ? "hr" : "hrs";
    const minuteLabel = minutes === 1 ? "min" : "mins";

    const hourPart = hours > 0 ? `${hours} ${hourLabel}` : "";
    const minutePart = minutes > 0 ? `${minutes} ${minuteLabel}` : "";

    return [hourPart, minutePart].filter(Boolean).join(" ");
  };

  return (
    <>
      <section className="mybookings-sec-container">
        <div className="mybookings-sec-container__tab-row">
          {tabs.map((tab, tabIndex) => (
            <div
              key={tabIndex}
              className={`mybookings-sec-container__tab-row__col ${
                activeTab === tab.key ? "col-active" : ""
              }`}
              onClick={() => handleChangeActiveTab(tab.key)}
            >
              <img
                src={tabIcons
                  .filter((item) => item.name === tab.key)
                  .map((source) => {
                    return activeTab === tab.key
                      ? source.enable
                      : source.disable;
                  })}
                alt="TabIcon"
              />
              <span>{tab.label}</span>
            </div>
          ))}
        </div>
        <div className="mybookings-sec-container__filter-row">
          {resultCountDesign()}
          <>
            <div className="filter-by-cntnr">
              <span
                onClick={() => setShowFilterSheet(!showFilterSheet)}
                className="filter-by-btn"
              >
                {filterOptionValue()}
                <img
                  src={ChevronIcon}
                  alt="ChevronIcon"
                  className={showFilterSheet ? "filter-by-opened" : ""}
                />
              </span>
              {!state.isMobile && showFilterSheet && (
                <ul className="filter-by-row" ref={fliterRef}>
                  {filterOptions.map((item, index) => {
                    return (
                      <li
                        key={index}
                        className="filter-by-option"
                        onClick={() => handleFilterChange(item.value)}
                      >
                        {item.label}
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          </>
        </div>
        {loading === "package"
          ? [1, 2, 3].map((item) => {
              return (
                <div className="mybooking-vacation-card" key={item}>
                  <ContentLoader height={140} speed={1} viewBox="0 0 380 70">
                    <rect x="0" y="0" rx="5" ry="5" width="70" height="70" />
                    <rect x="80" y="17" rx="4" ry="4" width="300" height="13" />
                    <rect x="80" y="40" rx="3" ry="3" width="250" height="10" />
                  </ContentLoader>
                </div>
              );
            })
          : displayBookingList()}
        {bookingList.length > 0 && (
          <div className="pagenation-cntnr">
            <ul className="pagenation-cntnr__row">
              <li
                className={`pagenation-cntnr__row__col-prev ${
                  page === 1 ? "disabled" : ""
                }`}
                onClick={() => setPage(page - 1)}
              >
                <img src={ExpandArrowIcon} alt="ExpandArrowIcon" />
              </li>
              {pageList.map((item, index) => {
                return (
                  <li
                    key={index}
                    className={`pagenation-cntnr__row__col ${
                      page === index + 1 ? "active" : ""
                    }`}
                    onClick={() => setPage(index + 1)}
                  >
                    <span>{item}</span>
                  </li>
                );
              })}
              <li
                className={`pagenation-cntnr__row__col-next ${
                  page === pageList.length ? "disabled" : ""
                }`}
                onClick={() => setPage(page + 1)}
              >
                <img src={ExpandArrowIcon} alt="ExpandArrowIcon" />
              </li>
            </ul>
          </div>
        )}
      </section>
      <BottomSheet
        open={showFilterSheet && state.isMobile}
        className="bottomSheetMain"
        onDismiss={() => setShowFilterSheet(false)}
      >
        <div className="searchContainer__bottomSheetMain__container">
          <div className="searchContainer__bottomSheetMain__container__sourceAir">
            {filterOptions?.map((option, index) => (
              <div
                key={index}
                className={`searchContainer__bottomSheetMain__container__sourceAir__row ${
                  selectedFilter === option?.value
                    ? "searchContainer__bottomSheetMain__container__sourceAir__row__active"
                    : ""
                }`}
                onClick={() => {
                  handleFilterChange(option?.value);
                  setShowFilterSheet(false);
                }}
              >
                {option?.label}
              </div>
            ))}
          </div>
        </div>
      </BottomSheet>
    </>
  );
};

const mapStateToProps = (state) => {
  let bookingList = [];
  let totalCount = 0;

  if (
    Array.isArray(state.bookinghistory) &&
    state.bookinghistory.length > 0 &&
    state.bookinghistory[0].status === "ok"
  ) {
    bookingList = state.bookinghistory[0].result_set || [];
    totalCount = state.bookinghistory[0].total_count || 0;
  }

  return {
    bookingList,
    totalCount,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getBookingHistory: (params) => {
      dispatch({ type: GET_BOOKINGHISTORY, params });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BookingAndCancellationCard);
